import { jsx as n } from "react/jsx-runtime";
import { Container as i, WIDTH_VAR as m, HEIGHT_VAR as a } from "./style.js";
function x({
  width: t = "100%",
  height: e = "1ex",
  animate: o,
  ...r
}) {
  return /* @__PURE__ */ n(
    i,
    {
      ...r,
      $animate: o,
      style: { [m]: t, [a]: e }
    }
  );
}
export {
  x as Skeleton
};
